import React, { useContext, useState, useEffect } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Card, Typography, Spin, Flex, Result, Button } from "antd";
import { GlobalSteps, StatusContext } from "../../../services/types";
import { generateProjectPDF } from "../../../services/api";

const StepPDF = () => {
    const statusContext = useContext(StatusContext);
    if (!statusContext) {
        throw new Error("missing context");
    }

    const { status, setStatus } = statusContext;
    const [pdfUrl, setPdfUrl] = useState<string>("");
    const [isGenerating, setIsGenerating] = useState<boolean>(false);

    useEffect(() => {
        if (!status.projectID) return;
        
        setIsGenerating(true);
        
        generateProjectPDF(status.projectID)
            .then((url) => {
                setPdfUrl(url);
                setIsGenerating(false);
            })
            .catch((error) => {
                console.error("PDF generation failed:", error);
                setIsGenerating(false);
                setStatus({
                    ...status,
                    globalStep: GlobalSteps.Fail,
                });
            });
    }, [status.projectID]);

    const handleDownload = () => {
        if (!pdfUrl) return;
        
        window.open(pdfUrl, '_blank');
    };

    return (
        <Card bordered={false}>
            {isGenerating ? (
                <Flex align="center" gap="middle" vertical>
                    <Typography.Text>PDF in progress</Typography.Text>
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
                </Flex>
            ) : (
                pdfUrl && (
                    <Result
                        status="success"
                        title="Book is ready"
                        extra={[
                            <Button type="primary" key="console" onClick={handleDownload}>
                                Download
                            </Button>
                        ]}
                    />
                )
            )}
        </Card>
    );
};

export default StepPDF;